module.exports = __webpack_public_path__ + "static/media/banner-3.982f6513.mp4";